// Texty mobilného draweru — slovenské dvojče locale/cs/mobileNav.js.

import { plural } from '../plural.js';

export default {
  closeMenu: 'Zavrieť menu',
  rootMenu: 'Hlavné menu',
  showAll: 'Zobraziť všetko',
  nav: 'Menu',
  support: 'Potrebujete poradiť?',
  showSubcats: 'Zobraziť podkategórie',
  search: {
    placeholder: 'Hľadať kategóriu…',
    clear: 'Vymazať hľadanie',
    empty: 'Nič sme nenašli. Skúste iný výraz, alebo prejdite kategórie nižšie.',
  },
  orderStatus: 'Stav objednávky',
  shop: {
    account: 'Prihlásenie / registrácia',
    claim: 'Reklamácia tovaru',
    withdrawal: 'Vrátenie do 14 dní',
  },
  site: {
    shipping: 'Doprava a platba',
    // SK: neověřeno ve fixtures — `page('store')` vrací null, odkaz se v UI
    // reálně nezobrazí (withPages).
    store: 'Kamenná predajňa Bílina',
    service: 'Servis náradia',
    b2b: 'B2B spolupráca',
    ratings: 'Hodnotenie obchodu',
    contact: 'Kontakty',
  },
  categoriesEyebrow: 'Kategórie',
  eyebrowShopping: 'Nakupovanie',
  categoryCount: (n) => n + ' ' + plural(n, ['kategória', 'kategórie', 'kategórií']),
  resultsCount: (n) => (n === 0 ? 'Žiadne výsledky' : n + ' ' + plural(n, ['výsledok', 'výsledky', 'výsledkov'])),
};
